import { Measurements } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-placeholder';

class BinCurrentVolume extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    if (this.volume === undefined) {
      return html`<bn-placeholder></bn-placeholder>`;
    }
    Measurements.get('volume').html({ volume: this.volume });
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.volume = this.entity.properties.volume;
  }
}

window.customElements.define('bin-current-volume', BinCurrentVolume);
